import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
let store = new Vuex.Store({
  // 1. state
  state: {
    readonly:false,//禁用上传
    zxsjFlag:false,//判断是否是app
    appShow:false,//是否展示获取权限描述
    to: "",
    from: "",
    buyerId: JSON.parse(localStorage.getItem("user_xinxi")) != null ? JSON.parse(localStorage.getItem("user_xinxi")).buyerId : "",
    tabNum: 0,
    timer:"",
    num:0,
    shows:false,
    zbURL:"",
    linkQrcode:"",
  },

  // // 2. getters
  getters: {
    // 参数列表state指的是state数据
    getCityFn(state) {
      return state.to;
    },
    getCityFns(state) {
      return state.from;
    }
  },
  // 4. mutations
  mutations: {
    tabs(state, option) {
      state[option.key] = option.value;
    },
    addCount(state, num) {
      state.to = num;
    },
    delCount(state, num) {
      state.from = num;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js